/* ============================================================
   CASA ABADÍA — Asesor "Abadía" (widget flotante) · Vanilla JS para Shopify
   Archivo: assets/ca-abadia.js
   - SOLO árbol de botones (sin IA). El texto libre deriva a WhatsApp.
   - Los productos recomendados se resuelven EN VIVO contra Shopify
     vía /search/suggest.json (precio/foto/link reales).
   - "Agregar" usa /products/<handle>.js -> primera variante -> /cart/add.js
   Tono: elegante, sobrio, sin emojis, sin guiones largos.
   ============================================================ */
(function () {
  "use strict";
  if (window.__abadiaLoaded) return;
  window.__abadiaLoaded = true;

  var WA = "523332581934";
  var LS = "abadia_chat_v1";
  var mq = window.matchMedia("(max-width: 480px)");

  // ---------- guía de medidas: personas -> medida ----------
  var DIN = { "4": "1.5m", "6": "2.0m", "8": "2.4m", "10": "3.0m", "12+": "3.5m" };
  function comedor(s) { return "Comedor de Parota " + s; }
  function banca(s) { return "Banca de Parota " + s; }
  function credenza(s) { return "Credenza de Parota " + s; }
  function uniq(a) { var o = []; a.forEach(function (x) { if (x && o.indexOf(x) < 0) o.push(x); }); return o; }

  // ---------- ÁRBOL (recs devuelven NOMBRES de producto o {q, n}) ----------
  var NODES = {
    start: {
      say: function () { return "Bienvenido a Casa Abadía. Soy Abadía y te acompaño a encontrar la pieza correcta para tu espacio. ¿Por dónde empezamos?"; },
      chips: function () { return [["Mi comedor", "din_people"], ["Mi sala", "sala_type"], ["Mi baño", "bath"], ["Detalles y decoración", "decor"], ["Ver por categoría", "cats"], ["Preguntas frecuentes", "faq"], ["Solo estoy mirando", "browse"]]; }
    },
    din_people: {
      say: function () { return "Empecemos por lo esencial: ¿cuántas personas quieres sentar con holgura? Así calculo el largo exacto de tu mesa."; },
      chips: function () { return ["4", "6", "8", "10", "12+"].map(function (n) { return [n + " personas", "din_rec", { size: DIN[n], people: n }]; }); }
    },
    din_rec: {
      say: function (c) { return "Para " + c.people + " personas, la medida de " + c.size + " es la justa: cada quien con su espacio, sin apreturas. Es parota maciza de una sola pieza, con acabado natural a la cera, hecha a mano bajo pedido en nuestro taller de Jalisco. Mira:"; },
      recs: function (c) { var alt = c.size === "3.5m" ? comedor("4.0m") : (c.size === "1.5m" ? comedor("1.8m") : null); return uniq([comedor(c.size), alt]); },
      chips: function () { return [["¿Cómo la siento?", "din_seat"], ["Bancas a juego", "din_bancas"], ["Una credenza", "din_credenza"], ["Me encanta, ¿qué sigue?", "wrap"]]; }
    },
    din_seat: {
      say: function () { return "Tienes dos caminos. La banca da un aire relajado y se guarda bajo la mesa; las sillas son más formales y cómodas para sobremesas largas. ¿Cuál va contigo?"; },
      chips: function () { return [["Banca", "din_bancas"], ["Sillas", "din_sillas"], ["Mezcla de ambas", "din_mix"]]; }
    },
    din_bancas: {
      say: function () { return "Buena elección. La banca de la misma medida de tu mesa acompaña sin estorbar el paso y suma lugares cuando llega visita. Va en la misma parota, para que todo hable el mismo idioma."; },
      recs: function (c) { return uniq([banca(c.size || "2.4m"), banca("2.4m")]).slice(0, 2); },
      chips: function () { return [["Y unas sillas", "din_sillas"], ["Una credenza", "din_credenza"], ["Listo así", "wrap"]]; }
    },
    din_sillas: {
      say: function () { return "Estas tres conviven muy bien con la parota: estructura firme, tapiz noble y una silueta que no pelea con la mesa. Son las que más recomiendo."; },
      recs: function () { return ["Silla Viena", "Silla Kualalumpure", "Silla Malasya"]; },
      chips: function () { return [["Una credenza", "din_credenza"], ["Listo así", "wrap"]]; }
    },
    din_mix: {
      say: function () { return "Mi combinación favorita: banca de un lado, sillas del otro y dos en las cabeceras. Se ve cuidado y rinde más lugares. Te dejo ambas piezas:"; },
      recs: function (c) { return [banca(c.size || "2.4m"), "Silla Viena", "Silla Malasya"]; },
      chips: function () { return [["Una credenza", "din_credenza"], ["Listo así", "wrap"]]; }
    },
    din_credenza: {
      say: function () { return "Para cerrar el comedor, la credenza guarda vajilla y mantel, y repite la veta de la mesa en la pared. Toda la línea está ahora en oferta, vale la pena aprovechar."; },
      recs: function (c) { return uniq([credenza(c.size || "2.0m"), "Credenza de Parota 2.4m"]).slice(0, 2); },
      chips: function () { return [["Me llevo el conjunto", "wrap"], ["Empezar de nuevo", "start"]]; }
    },
    sala_type: {
      say: function () { return "Tu sala es donde se reúne la casa. ¿Qué pieza quieres resolver primero? Puedo armarte el conjunto completo pieza por pieza."; },
      chips: function () { return [["Mesa de centro", "mesa_size"], ["Un tapete", "tapete_style"], ["Una lámpara", "lamp_type"], ["Un sillón", "sillon_rec"]]; }
    },
    mesa_size: {
      say: function () { return "La mesa de centro marca el ritmo de la sala. Cuéntame el tamaño de tu espacio y te doy la proporción correcta."; },
      chips: function () { return [["Sala amplia", "mesa_rec", { mesa: "amplia" }], ["Sala compacta", "mesa_rec", { mesa: "compacta" }], ["Quiero algo de autor", "mesa_rec", { mesa: "autor" }]]; }
    },
    mesa_rec: {
      say: function (c) { return c.mesa === "autor" ? "Estas son piezas de autor, talladas de un solo bloque de madera maciza. Ninguna se repite: la que elijas será única en el mundo." : (c.mesa === "amplia" ? "Para una sala amplia conviene una mesa generosa que llene el centro sin perderse. Estas proporciones lucen muy bien:" : "En una sala compacta, una pieza de líneas limpias rinde más y deja circular. Estas tres son ideales:"); },
      recs: function (c) {
        if (c.mesa === "amplia") return ["Mesa de Centro 2.0m x 1.5m", "Mesa de Centro 1.5m x 1.5m", "Mesa de Centro 2.0m x 2.0m"];
        if (c.mesa === "compacta") return ["Mesa de Centro Cubo", "Mesa de Centro Zoey", "Mesa de Centro Torcida"];
        return ["Mesa de Centro Barril", "Mesa de Centro Bowl", "Mesa de Centro Syar"];
      },
      chips: function () { return [["Un tapete que la ancle", "tapete_style"], ["Una lámpara", "lamp_type"], ["Listo así", "wrap"]]; }
    },
    tapete_style: {
      say: function () { return "El tapete define el área y da calidez bajo los pies. ¿Lo prefieres liso, para dejar que mande la madera, o estampado, para dar carácter?"; },
      chips: function () { return [["Liso y cálido", "tapete_rec", { tap: "liso" }], ["Con estampado", "tapete_rec", { tap: "est" }]]; }
    },
    tapete_rec: {
      say: function () { return "Todos están tejidos a mano. Estos son los que más salen y los que mejor envejecen:"; },
      recs: function (c) { return c.tap === "liso" ? ["Tapete Shaggy", "Tapete cola de conejo"] : [{ q: "Tapete Estampado", n: 3 }]; },
      chips: function () { return [["Una lámpara", "lamp_type"], ["Listo así", "wrap"]]; }
    },
    lamp_type: {
      say: function () { return "La luz cambia por completo una sala. ¿Buscas una lámpara de mesa para lectura, una de techo para vestir el espacio, o una pieza escultural que sea protagonista?"; },
      chips: function () { return [["De mesa", "lamp_rec", { lamp: "mesa" }], ["De techo", "lamp_rec", { lamp: "techo" }], ["Escultural", "lamp_rec", { lamp: "esc" }]]; }
    },
    lamp_rec: {
      say: function (c) { return c.lamp === "esc" ? "Estas son piezas de conversación: dan luz cálida y funcionan como escultura aunque estén apagadas." : "Luz cálida y hechura a mano. Estas tres son mis favoritas para empezar:"; },
      recs: function (c) {
        if (c.lamp === "mesa") return ["Lámpara Gumer", "Lámpara Bilbao", "Lámpara Cadiz"];
        if (c.lamp === "techo") return ["Lámpara Estrella", "Lámpara Pumpkin", "Lámpara Umbrella"];
        return ["Lámpara Meduza", "Lámpara Tentaleon", "Lámpara Level"];
      },
      chips: function () { return [["Una mesa de centro", "mesa_size"], ["Listo así", "wrap"]]; }
    },
    sillon_rec: {
      say: function () { return "Dos sillones con carácter, pensados para acompañar sin robar protagonismo a la madera:"; },
      recs: function () { return ["Sillón Seul", "Sillón Gotemburgo"]; },
      chips: function () { return [["Una mesa de centro", "mesa_size"], ["Listo así", "wrap"]]; }
    },
    bath: {
      say: function () { return "Nuestros lavabos se tallan en un solo bloque de mármol natural, así que la veta es irrepetible: tu pieza no existe en ningún otro baño. ¿La imaginas en tono claro u oscuro?"; },
      chips: function () { return [["Tonos claros", "bath_rec", { bath: "clara" }], ["Tonos oscuros", "bath_rec", { bath: "oscura" }], ["Sorpréndeme", "bath_rec", { bath: "x" }]]; }
    },
    bath_rec: {
      say: function (c) { return c.bath === "oscura" ? "Los tonos oscuros dan un baño elegante y de noche se ven espectaculares con luz cálida. Estas son una joya:" : (c.bath === "clara" ? "Los claros aportan amplitud y luz; combinan con casi cualquier grifería. Te recomiendo estas:" : "Déjame elegir por ti. Estas son las que más enamoran a quien entra a verlas:"); },
      recs: function () { return [{ q: "Lavabo de Mármol", n: 2 }]; },
      chips: function () { return [["Accesorios de mármol", "decor_marmol"], ["Listo así", "wrap"]]; }
    },
    decor: {
      say: function () { return "Los detalles son los que terminan de contar la historia de una casa. ¿Qué te late ver?"; },
      chips: function () { return [["Piezas de mármol", "decor_marmol"], ["Macetas", "decor_macetas"], ["Espejos y objetos", "decor_obj"]]; }
    },
    decor_marmol: {
      say: function () { return "Mármol natural tallado a mano, para sumar una nota noble sobre una mesa o repisa:"; },
      recs: function () { return ["Buda", "Ajedrez", "Escultura de perro globo en Mármol"]; },
      chips: function () { return [["Ver lavabos de mármol", "bath"], ["Listo así", "wrap"]]; }
    },
    decor_macetas: {
      say: function () { return "Macetas con carácter para interior y terraza, que visten una planta sin competir con ella:"; },
      recs: function () { return ["Maceta Skill", "Maceta Cono", "Maceta Cigarro"]; },
      chips: function () { return [["Listo así", "wrap"], ["Empezar de nuevo", "start"]]; }
    },
    decor_obj: {
      say: function () { return "Esos objetos que terminan un espacio y dan de qué hablar:"; },
      recs: function () { return ["Espejo Ojo", "Decoración Perro", "Revistero Marmol"]; },
      chips: function () { return [["Listo así", "wrap"], ["Empezar de nuevo", "start"]]; }
    },
    browse: {
      say: function () { return "Con gusto, mira a tu ritmo. Para inspirarte, estas tres piezas resumen lo que es Casa Abadía. Si alguna te llama, te cuento más:"; },
      recs: function () { return ["Comedor de Parota 2.4m", "Sillón Seul", "Lavabo de Mármol"]; },
      chips: function () { return [["Quiero un comedor", "din_people"], ["Algo para la sala", "sala_type"], ["Para el baño", "bath"], ["Detalles y decoración", "decor"]]; }
    },
    cats: {
      say: function () { return "Claro. ¿Qué categoría quieres ver?"; },
      chips: function () { return [["Comedores", "din_people"], ["Sillas", "din_sillas"], ["Mesas de centro", "mesa_size"], ["Lámparas", "lamp_type"], ["Tapetes", "tapete_style"], ["Lavabos de mármol", "bath"], ["Decoración", "decor"]]; }
    },
    faq: {
      say: function () { return "Con gusto. ¿Qué te gustaría saber?"; },
      chips: function () { return [["Tiempos de entrega", "faq_ans", { faq: "tiempos" }], ["Envíos", "faq_ans", { faq: "envio" }], ["Pago a meses", "faq_ans", { faq: "pago" }], ["Garantía", "faq_ans", { faq: "garantia" }], ["Personalización", "faq_ans", { faq: "personalizacion" }], ["Cuidado de la madera", "faq_ans", { faq: "cuidado" }], ["Horarios y contacto", "faq_ans", { faq: "contacto" }]]; }
    },
    faq_ans: {
      say: function (c) {
        var m = {
          tiempos: "Todas las piezas se hacen a mano bajo pedido; no manejamos stock. El tiempo de entrega va de 0 a 35 días hábiles según la pieza y la temporada.",
          envio: "Enviamos asegurado a toda la República con Castores, 3 Guerras o DHL. El costo se calcula automáticamente al finalizar tu compra, según tu dirección.",
          pago: "Sí, manejamos pago a meses y varias formas de pago: tarjetas, Apple Pay, Google Pay, PayPal y Shop Pay. La opción de meses la eliges al pagar.",
          garantia: "Cada pieza tiene garantía. Si llega con daño de envío, revísala al recibir y deja constancia en la guía. Por defectos de fabricación, presenta tu cotización. Los detalles te los confirma un asesor por WhatsApp.",
          personalizacion: "Como todo se hace bajo pedido, podemos ajustar la medida y el color de la madera: Natural, Miel, Nogal, Ébano o Hueso. Para algo más específico, te atiende un asesor por WhatsApp.",
          cuidado: "Limpia con paño seco o ligeramente húmedo, evita el sol directo permanente y el exceso de humedad, y renueva la cera una o dos veces al año.",
          contacto: "Te atendemos de 9 am a 6 pm. Escríbenos por aquí o por WhatsApp y con gusto te ayudamos."
        };
        return m[c.faq] || "Con gusto. ¿Sobre qué te gustaría saber?";
      },
      chips: function () { return [["Otra duda", "faq"], ["WhatsApp", "__wa"], ["Empezar de nuevo", "start"]]; }
    },
    wrap: {
      say: function () { return "Excelente elección. Quedo a la orden para lo que necesites: medidas a tu gusto, plazos de entrega, garantía o forma de pago. Escríbeme aquí mismo o sigamos con un asesor por WhatsApp."; },
      chips: function () { return [["Tengo una duda", "ask"], ["Empezar de nuevo", "start"], ["WhatsApp", "__wa"]]; }
    },
    ask: {
      say: function () { return "Con gusto. Escríbeme tu duda aquí abajo (tiempos de fabricación, envío, personalización de medidas o cuidado de la madera) y te paso con un asesor por WhatsApp para resolverla al momento."; },
      chips: function () { return [["Empezar de nuevo", "start"], ["WhatsApp", "__wa"]]; }
    }
  };

  // ---------- Shopify AJAX: resolver producto EN VIVO ----------
  function searchProducts(q, n) {
    var url = "/search/suggest.json?q=" + encodeURIComponent(q) + "&resources[type]=product&resources[limit]=" + (n || 4) + "&resources[options][unavailable_products]=last";
    return fetch(url, { headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        try { return (j.resources.results.products) || []; } catch (e) { return []; }
      })
      .catch(function () { return []; });
  }
  // recibe un item (nombre string o {q,n}) -> array de productos resueltos
  function resolveItem(item) {
    if (item && typeof item === "object" && item.q) {
      return searchProducts(item.q, item.n || 3).then(function (ps) { return ps.slice(0, item.n || 3); });
    }
    var name = String(item);
    return searchProducts(name, 5).then(function (ps) {
      if (!ps.length) return [];
      var exact = ps.filter(function (p) { return (p.title || "").trim().toLowerCase() === name.trim().toLowerCase(); })[0];
      return [exact || ps[0]];
    });
  }
  function resolveRecs(items) {
    return Promise.all((items || []).map(resolveItem)).then(function (groups) {
      var out = [], seen = {};
      groups.forEach(function (g) { (g || []).forEach(function (p) { if (p && !seen[p.handle]) { seen[p.handle] = 1; out.push(p); } }); });
      return out.slice(0, 3);
    });
  }
  function addToCart(handle) {
    return fetch("/products/" + handle + ".js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
      .then(function (prod) {
        var v = (prod.variants || []).filter(function (x) { return x.available; })[0] || (prod.variants || [])[0];
        if (!v) return false;
        return fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) }).then(function (r) { return r.ok; });
      }).catch(function () { return false; });
  }

  // ---------- estado ----------
  var saved = null; try { saved = JSON.parse(localStorage.getItem(LS) || "null"); } catch (e) {}
  var st = { msgs: (saved && saved.msgs) || [], node: (saved && saved.node && NODES[saved.node]) ? saved.node : "start", ctx: (saved && saved.ctx) || {} };
  var booted = false;
  function persist() { try { localStorage.setItem(LS, JSON.stringify({ msgs: st.msgs.slice(-30), node: st.node, ctx: st.ctx })); } catch (e) {} }

  // ---------- DOM ----------
  var root = document.createElement("div"); root.className = "cab"; document.body.appendChild(root);
  var open = false;
  function $(tag, cls, txt) { var e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; }

  var launcher, panel, scroll, chipsBar, input;
  function build() {
    launcher = $("button", "cab-launcher"); launcher.type = "button"; launcher.setAttribute("aria-label", "Abrir asesor Abadía");
    launcher.appendChild($("span", "cab-mono", "A"));
    launcher.appendChild($("span", "cab-launcher__txt", "Abadía · Asesor"));
    launcher.addEventListener("click", openChat);
    root.appendChild(launcher);

    panel = $("div", "cab-panel"); panel.setAttribute("role", "dialog"); panel.setAttribute("aria-label", "Asesor Abadía"); panel.style.display = "none";
    var head = $("div", "cab-head");
    head.appendChild($("span", "cab-mono", "A"));
    var ht = $("div", "cab-head__t");
    ht.appendChild($("div", "cab-head__name", "Abadía"));
    ht.appendChild($("div", "cab-head__sub", "Asesor de Casa Abadía"));
    head.appendChild(ht);
    var reset = $("button", "cab-icon", "↺"); reset.type = "button"; reset.title = "Empezar de nuevo"; reset.addEventListener("click", function () { st.msgs = []; st.ctx = {}; booted = true; while (scroll.firstChild) scroll.removeChild(scroll.firstChild); chipsBar = null; enter("start"); });
    var close = $("button", "cab-icon", "✕"); close.type = "button"; close.setAttribute("aria-label", "Cerrar"); close.addEventListener("click", function () { setOpen(false); });
    head.appendChild(reset); head.appendChild(close);
    panel.appendChild(head);

    scroll = $("div", "cab-scroll"); scroll.setAttribute("aria-live", "polite"); panel.appendChild(scroll);

    var foot = $("div", "cab-foot");
    input = $("input", "cab-input"); input.type = "text"; input.placeholder = "Escribe tu duda: medidas, plazos, garantía…";
    input.addEventListener("keydown", function (e) { if (e.key === "Enter") send(); });
    var snd = $("button", "cab-send", "Enviar"); snd.type = "button"; snd.addEventListener("click", send);
    foot.appendChild(input); foot.appendChild(snd);
    panel.appendChild(foot);
    root.appendChild(panel);
  }

  function scrollDown() { if (scroll) scroll.scrollTop = scroll.scrollHeight; }
  function bubbleBot(text) { var b = $("div", "cab-bot", text); scroll.appendChild(b); scrollDown(); }
  function bubbleUser(text) { var b = $("div", "cab-user", text); scroll.appendChild(b); scrollDown(); }

  function fmtPrice(v) { var n = parseFloat(v); if (isNaN(n)) return ""; return "$" + Math.round(n).toLocaleString("es-MX"); }
  function productCard(p) {
    var card = $("a", "cab-card"); card.setAttribute("href", p.url || "#"); card.target = "_blank"; card.rel = "noopener";
    var fi = p.featured_image; // ahora suggest.json devuelve featured_image como objeto {url,...}
    var imgUrl = String((fi && fi.url) || (typeof fi === "string" ? fi : "") || p.image || "").replace(/['"()]/g, "");
    var imgEl = $("div", "cab-card__img"); if (imgUrl) imgEl.style.backgroundImage = "url('" + imgUrl + "')";
    var info = $("div", "cab-card__info");
    info.appendChild($("div", "cab-card__name", p.title || ""));
    info.appendChild($("div", "cab-card__price", fmtPrice(p.price)));
    var btns = $("div", "cab-card__btns");
    var add = $("button", "cab-add", "Agregar"); add.type = "button";
    var ver = $("span", "cab-ver", "Ver");
    btns.appendChild(add); btns.appendChild(ver);
    info.appendChild(btns);
    card.appendChild(imgEl); card.appendChild(info);
    ver.addEventListener("click", function (e) { e.preventDefault(); window.open(p.url, "_blank"); });
    add.addEventListener("click", function (e) {
      e.preventDefault(); e.stopPropagation();
      addToCart(p.handle).then(function (ok) {
        if (ok) { document.dispatchEvent(new CustomEvent("abadia:cart-added", { detail: { handle: p.handle } })); toast((p.title || "Producto") + " · agregado al carrito"); }
        else { window.open(p.url, "_blank"); }
      });
    });
    return card;
  }

  function renderRecs(items) {
    var wrap = $("div", "cab-cards"); scroll.appendChild(wrap); scrollDown();
    resolveRecs(items).then(function (ps) {
      if (!ps.length) { wrap.remove(); return; }
      ps.forEach(function (p) { wrap.appendChild(productCard(p)); });
      scrollDown();
    });
  }

  function renderChips() {
    if (chipsBar) chipsBar.remove();
    var node = NODES[st.node];
    var chips = (node && node.chips) ? node.chips(st.ctx) : [];
    if (["start", "cats", "faq"].indexOf(st.node) < 0) chips = chips.concat([["Ver otra zona", "cats"]]);
    chipsBar = $("div", "cab-chips");
    chips.forEach(function (c) {
      var b = $("button", "cab-chip", c[0]); b.type = "button";
      b.addEventListener("click", function () { onChip(c[0], c[1], c[2]); });
      chipsBar.appendChild(b);
    });
    scroll.appendChild(chipsBar); scrollDown();
  }

  function enter(id, patch) {
    if (patch) for (var k in patch) st.ctx[k] = patch[k];
    var node = NODES[id]; if (!node) return;
    st.node = id;
    var text = node.say(st.ctx);
    st.msgs.push({ from: "bot", text: text }); bubbleBot(text);
    if (node.recs) { var items = node.recs(st.ctx); if (items && items.length) renderRecs(items); }
    renderChips(); persist();
  }

  function onChip(label, next, patch) {
    if (next === "__wa") { openWA(); return; }
    st.msgs.push({ from: "user", text: label }); bubbleUser(label);
    enter(next, patch);
  }

  function send() {
    var q = (input.value || "").trim(); if (!q) return; input.value = "";
    st.msgs.push({ from: "user", text: q }); bubbleUser(q);
    var t = "Con gusto te ayudo con eso. Te paso con un asesor por WhatsApp para responderte al momento.";
    st.msgs.push({ from: "bot", text: t }); bubbleBot(t);
    openWA(q); persist();
  }

  function openWA(q) {
    var txt = q ? q : "Hola, vengo del sitio de Casa Abadía, ¿me pueden asesorar?";
    window.open("https://wa.me/" + WA + "?text=" + encodeURIComponent(txt), "_blank");
  }

  function setOpen(v) {
    open = v;
    panel.style.display = v ? "flex" : "none";
    launcher.style.display = v ? "none" : "flex";
  }
  function openChat() {
    setOpen(true);
    if (booted) return;
    booted = true;
    if (st.msgs.length === 0) { enter("start"); }
    else {
      st.msgs.forEach(function (m) { if (m.from === "user") bubbleUser(m.text); else bubbleBot(m.text); });
      renderChips();
    }
  }

  var toastEl;
  function toast(msg) {
    if (!toastEl) { toastEl = $("div", "cab-toast"); root.appendChild(toastEl); }
    toastEl.textContent = "✓ " + msg; toastEl.classList.add("on");
    clearTimeout(window.__cabToast); window.__cabToast = setTimeout(function () { toastEl.classList.remove("on"); }, 2600);
  }

  // ---------- init ----------
  build();
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && open) setOpen(false); });
  document.addEventListener("abadia:open", openChat);
  window.AbadiaOpen = openChat;
})();
